import { RefObject, useEffect, useState } from "react";


const useIsVisible = (ref: RefObject<HTMLDivElement>, options: IntersectionObserverInit): boolean => {
    const [isIntersecting, setIntersecting] = useState<boolean>(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) =>
            setIntersecting(entry.isIntersecting)
        , options);

        ref.current && observer.observe(ref.current);

        return () => {
            observer.disconnect();
        };

    }, [ref]);

    return isIntersecting;
}

export default useIsVisible